// extracted by mini-css-extract-plugin
export var deleteIcon = "_rf-5";
export var deleteOption = "_rf-3";
export var divider = "_rf-2";
export var downloadIcon = "_rf-4";
export var drawer = "_rf-0";
export var drawerFooter = "_rf-6";
export var drawerOpen = "_rf-1";
export var highlighted = "_rf-7";
export var lighterHighlight = "_rf-8";